const language = {
	spanish: {
		route: "Inicio / Recursos / Preguntas Frecuentes",
		preguntas_title: "Preguntas Frecuentes",
		categoria_1: "INSTALACIÓN",
		categoria_2: "SOPORTE",
		categoria_3: "SOLUCIONES",
		categoria_4: "TECNOLOGÍA",
		categoria_5: "SEGURIDAD",
		categoria_6: "TRACKING",
		instalacion_title: "Instalación",
		pregunta_1:
			"No he encontrado mi dispositivo en la lista de hardware compatible con Foresight GPS. ¿Qué tengo que hacer?",
		pregunta_2:
			"Quiero usar dispositivos Foresight GPS u otros dispositivos similares con Foresight GPS.",
		pregunta_3: "¿Qué rastreador funciona mejor con Wialon?",
		respuesta_1: [
			"ForesightGPS no vende el hardware. Somos exclusivamente el desarrollador de software. Sin embargo, informamos a nuestrosclientes sobre los dispositivos compatibles con la plataforma ForesightGPS.",
			"Por lo tanto, póngase en contacto con el fabricante o su proveedor para obtener el dispositivo que le interesa.",
		],
		respuesta_2: "¿Qué rastreador funciona mejor con Wialon?",
		respuesta_default:
			"Lorem ipsum dolor sit amet, consectetur adipiscing elit.Suspendisse malesuada lacus ex, sit amet blandit leo lobortis eget.",
	},
	english: {
		route: "Home / Resources / Frequently Asked Questions",
		preguntas_title: "Frequently Asked Questions",
		categoria_1: "INSTALLATION",
		categoria_2: "SUPPORT",
		categoria_3: "SOLUTIONS",
		categoria_4: "TECHNOLOGY",
		categoria_5: "SECURITY",
		categoria_6: "TRACKING",
		instalacion_title: "Installation",
		pregunta_1:
			"I did not find my device in the Foresight GPS supported hardware list, what should I do?",
		pregunta_2:
			"I want to use Foresight GPS devices or other similar devices with Foresight GPS.",
		pregunta_3: "¿Which tracker works best with Wialon?",
		respuesta_1: [
			"ForesightGPS does not sell hardware. We are exclusively the software developer. However, we inform our customers about the devices compatible with the ForesightGPS platform.",
			"Therefore, please contact the manufacturer or your supplier to obtain the device you are interested in.",
		],
		respuesta_2: "¿Which tracker works best with Wialon?",
		respuesta_default:
			"Lorem ipsum dolor sit amet, consectetur adipiscing elit.Suspendisse malesuada lacus ex, sit amet blandit leo lobortis eget.",
	},
};

export default language;